import React, {PureComponent} from 'react'
import TextMask from 'react-text-mask'
import {Button} from 'reactstrap'
import PropTypes from 'prop-types'

import {setFieldValueGen} from '../helpers/utils'
import FormItem from './FormItem'
import Input from './Input'
import {masks} from '../helpers/format'
import {isValidDate, moneyToValue, readDate} from '../helpers/form'
import GoKids from '../services/GoKids'
import {getErrorMessage} from '../helpers/errors'

class DriverPaymentForm extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {template: {}};
    this.setFieldValue = setFieldValueGen(this, 'template');
  }

  handleSubmit = async e => {
    e.preventDefault();

    const driverId = this.props.driverId;
    const {template} = this.state;

    let errorMessage = validateTemplate(template);
    if (errorMessage) return this.setState({isSubmitting: false, errorMessage});

    try {
      this.setState({isSubmitting: true, errorMessage: null});
      const data = readFromTemplate(template);
      const payment = await GoKids.addPayment(driverId, data);
      await this.props.onCreate(payment);
      this.setState({isSubmitting: false, template: {}});
    } catch (err) {
      const errorMessage = getErrorMessage(err);
      this.setState({isSubmitting: false, errorMessage});
    }
  };

  render() {
    const infoFields = this.renderInfoFields();

    return (
      <form onSubmit={this.handleSubmit}>
        <div className="card-form-body">
          <h4 className="form-subheader">Registrar novo pagamento</h4>
          {infoFields}
          <div className="form-actions">
            <span className="flex text-danger">
              {this.state.errorMessage || ''}
            </span>
            <Button
              disabled={this.state.isSubmitting}
              color="primary" type="submit">Registrar pagamento</Button>
          </div>
        </div>
      </form>
    );
  }

  renderInfoFields = () => {
    const {template} = this.state;
    return (
      <React.Fragment>
        <FormItem label="Data do pagamento">
          <Input
            name="date"
            value={template.date}
            onChange={this.setFieldValue}
            tag={TextMask}
            mask={masks.date}
            pipe={masks.datePipe}
            keepCharPositions/>
        </FormItem>
        <FormItem label="Valor">
          <Input
            name="value"
            value={template.value}
            onChange={this.setFieldValue}
            tag={TextMask}
            mask={masks.money}/>
        </FormItem>
      </React.Fragment>
    )
  };
}

DriverPaymentForm.propTypes = {
  onCreate: PropTypes.func.isRequired,
};

const readFromTemplate = template => ({
  value: moneyToValue(template.value),
  date: readDate(template.date),
});

const validateTemplate = template => {
  if (!template.date || !isValidDate(template.date)) return 'Preencha a data que o pagamento foi realizado. Formato: DD/MM/AAAA';
  if (!template.value) return 'Preencha o valor do pagamento';
};

export default DriverPaymentForm;



// WEBPACK FOOTER //
// ./src/components/DriverPaymentForm.js